<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 38 38">
        <g transform="translate(-1300 -85)">
            <circle class="a" cx="19" cy="19" r="19" transform="translate(1300 85)" fill="#383935"/>
            <g transform="translate(1312.759 97.35)">
                <g transform="translate(5.219 3.783)">
                    <g transform="translate(5.224)">
                        <path class="b" d="M99.729,42.605a.461.461,0,0,1-.337-.137.47.47,0,0,1,0-.673l2.515-2.515-2.515-2.515a.476.476,0,0,1,.673-.673l2.841,2.862a.47.47,0,0,1,0,.673l-2.851,2.851A.47.47,0,0,1,99.729,42.605Z" transform="translate(-99.25 -35.95)" fill="#a5d867" stroke="#a5d867" stroke-width="0.5px"/>
                    </g>
                    <g transform="translate(0 2.867)">
                        <path class="b" d="M57.67,64.147h-7.6a.473.473,0,1,1,0-.947h7.6a.473.473,0,1,1,0,.947Z" transform="translate(-49.6 -63.2)" fill="#a5d867" stroke="#a5d867" stroke-width="0.5px"/>
                    </g>
                </g>
                <path class="b" d="M8.07,14.236H2.378A2.373,2.373,0,0,1,0,11.869V2.378A2.375,2.375,0,0,1,2.378,0H8.07a.473.473,0,1,1,0,.947H2.378A1.432,1.432,0,0,0,.947,2.378v9.491a1.421,1.421,0,0,0,1.42,1.42H8.06a.472.472,0,0,1,.473.473A.456.456,0,0,1,8.07,14.236Z" fill="#a5d867" stroke="#a5d867" stroke-width="0.5px"/>
            </g>
        </g>
    </svg>
</template>

<script>
export default {
  name: 'UserLogoutIcon'
}
</script>

<style scoped>
    svg {
        width:38px;
        height: 38px;
    }
</style>